/**
 * @generated SignedSource<<1df0d09ab0f4f588d1788b635e7fe0c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AgenticWorkerResultState = "NEEDS_REVIEW" | "DONE" | "DELETED" | "%future added value";
export type AgenticWorkerRowType = "PROJECT_BILLING_ROW" | "RETAINER_PERIOD_ROW" | "%future added value";
export type AgenticWorkerRunState = "RUNNING" | "STOPPED" | "NOTHING_FOUND" | "PRODUCED" | "FAILED" | "NOT_STARTED" | "%future added value";
export type AgenticWorkerRunStateReason = "ALREADY_RUNNING" | "TIMED_OUT" | "EXECUTOR_ERROR" | "%future added value";
export type AgenticWorkerScopeKind = "PAGE" | "ROW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type agentRunState_worker$data = {
  readonly activeRuns: ReadonlyArray<{
    readonly id: string;
    readonly scopeKind: AgenticWorkerScopeKind;
    readonly scopeRowType: AgenticWorkerRowType | null;
    readonly scopeRowId: number | null;
    readonly state: AgenticWorkerRunState;
    readonly rows: ReadonlyArray<{
      readonly rowType: AgenticWorkerRowType;
      readonly rowId: number;
    }>;
  }>;
  readonly lastRun: {
    readonly id: string;
    readonly scopeKind: AgenticWorkerScopeKind;
    readonly scopeRowType: AgenticWorkerRowType | null;
    readonly scopeRowId: number | null;
    readonly state: AgenticWorkerRunState;
    readonly rows: ReadonlyArray<{
      readonly rowType: AgenticWorkerRowType;
      readonly rowId: number;
    }>;
    readonly stateReason: AgenticWorkerRunStateReason | null;
    readonly foundDetail: string | null;
  } | null;
  readonly waitingResults: ReadonlyArray<{
    readonly id: string;
    readonly runId: string;
    readonly rows: ReadonlyArray<{
      readonly rowType: AgenticWorkerRowType;
      readonly rowId: number;
    }>;
    readonly state: AgenticWorkerResultState;
    readonly hidden: boolean;
    readonly producedAt: string | null;
  }>;
  readonly " $fragmentType": "agentRunState_worker";
};
export type agentRunState_worker$key = {
  readonly " $data"?: agentRunState_worker$data;
  readonly " $fragmentSpreads": FragmentRefs<"agentRunState_worker">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopeKind",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopeRowType",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopeRowId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AgenticWorkerResultRow",
  "kind": "LinkedField",
  "name": "rows",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "agentRunState_worker",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AgenticWorkerRun",
      "kind": "LinkedField",
      "name": "activeRuns",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AgenticWorkerRun",
      "kind": "LinkedField",
      "name": "lastRun",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stateReason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "foundDetail",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AgenticWorkerResult",
      "kind": "LinkedField",
      "name": "waitingResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "runId",
          "storageKey": null
        },
        (v5/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hidden",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "producedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AgenticWorker",
  "abstractKey": null
};
})();

(node as any).hash = "19f6d8bc2d6f71214c3dfeb48dc4749b";

export default node;
